export default __webpack_public_path__ + "static/ncsacw-logo-924c00db65b89cdf152d0ee74dd79f27.svg";